var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCotacoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.5H13.2C12.7 2.5 12.2 2.7 11.9 3.05L4.6 10.35",
    stroke: "#EA5D0E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.5V10.2C21 10.7 20.8 11.2 20.45 11.55L11.55 20.45C10.8 21.2 9.6 21.2 8.85 20.45L4.55 16.15C3.8 15.4 3.8 14.2 4.55 13.45L13.45 4.55C13.8 4.2 14.3 4 14.8 4H19.5C20.3 4 21 4.7 21 5.5Z",
    stroke: "#EA5D0E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.75C17.94 8.75 18.5 8.19 18.5 7.5C18.5 6.81 17.94 6.25 17.25 6.25C16.56 6.25 16 6.81 16 7.5C16 8.19 16.56 8.75 17.25 8.75Z",
    stroke: "#EA5D0E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotacoes);
export default __webpack_public_path__ + "static/media/cotacoes.f3deea66b7d31bd276c6e95e5d0044aa.svg";
export { ForwardRef as ReactComponent };